import React from 'react';
import { useTheme } from 'styled-components';
import { Link, useLocation } from 'react-router-dom';

function Navbar({ user, onLogout }) {
  const theme = useTheme();
  const location = useLocation();

  const navStyle = { padding: '1rem 0' };
  const ulStyle = { listStyle: 'none', display: 'flex', justifyContent: 'center', gap: '3rem', margin: 0, padding: 0 };
  const liStyle = { textDecoration: 'none', color: theme.colors.text, cursor: 'pointer', paddingBottom: '0.3rem', position: 'relative', transition: 'color 0.3s ease', display: 'inline-block' };
  const activeStyle = { color: theme.colors.primary, borderBottom: `2px solid ${theme.colors.primary}` };

  return (
    <nav style={navStyle}>
      <ul style={ulStyle}>
        <li>
          <Link to="/" style={{ ...liStyle, ...(location.pathname === '/' ? activeStyle : {}) }}>
            Početna
          </Link>
        </li>
        <li>
          <Link to="/pretrazi" style={{ ...liStyle, ...(location.pathname === '/pretrazi' ? activeStyle : {}) }}>
            Pretraživanje
          </Link>
        </li>

        {!user ? (
          <li>
            <Link to="/prijava" style={{ ...liStyle, ...(location.pathname === '/prijava' ? activeStyle : {}) }}>
              Prijava
            </Link>
          </li>
        ) : (
          <li style={liStyle}>
            <Link
              to="/"
              onClick={onLogout}
              style={{ ...liStyle, ...(location.pathname === '/odjava' ? activeStyle : {}) }}
            >
              Odjava
            </Link>
          </li>
        )}
      </ul>
    </nav>
  );
}

export default Navbar;
